// The environment is loaded from the backend server from /api/env.js
//
// See index.html  line: <script type="text/javascript" src="/api/env.js"></script>

import { coerceBooleanProperty } from '@angular/cdk/coercion'

export const isProdMode = (): boolean => coerceBooleanProperty(environment.production)

export const isKafentEnabled = (): boolean => coerceBooleanProperty(environment.kafentEnabled)

export const isPackageSharingEnabled = (): boolean =>
  coerceBooleanProperty(environment.batchPackageSharingEnabled)

export const isTerminalPackageUiEnabled = (): boolean =>
  coerceBooleanProperty(environment.terminalPackageUiEnabled)

export const isUtilizationTuningEnabled = (): boolean =>
  coerceBooleanProperty(environment.utilizationTuningEnabled)

export const isSecurityMockEnabled = (): boolean =>
  coerceBooleanProperty(environment.securityMockEnabled)

/**
 * All environment variables are strings
 */
export interface Environment {
  apiPath: string
  production: string
  issuerUrl: string
  clientId: string
  scope: string
  roleHierarchy: string
  version: string
  kafentEnabled: string
  kafent: string
  kafentWorkItemEvents: string
  storageManagementUrl: string
  storageTerminalUrl: string
  utilizationTuningEnabled?: string
  batchPackageSharingEnabled?: string
  terminalPackageUiEnabled?: string
  securityMockEnabled?: string
}

export const environment: Environment = (window as any).env
